export { default as CookClasses } from './CookClasses';



// WEBPACK FOOTER //
// ./src/components/CookClasses/index.js